import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Platform } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DswMediumIconButtonDirective, DswSuffixDirective } from '@vi-succ/design-system-web';
import { Catalog } from '@vi-succ/products-domain';
import { CatalogSwitcherComponent, SalesOrg } from './catalog-switcher/catalog-switcher.component';

export interface CatalogSwitcherDialogData {
  currentCatalog: Catalog | null;
  saveButtonLabel: string;
  salesOrgs: { [key: string]: SalesOrg };
  showCancel: boolean;
}

@Component({
  selector: 'et-catalog-switcher-dialog',
  templateUrl: './catalog-switcher-dialog.component.html',
  styleUrls: ['./catalog-switcher-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    CatalogSwitcherComponent,
    TranslateModule,
    DswMediumIconButtonDirective,
    DswSuffixDirective,
  ],
})
export class CatalogSwitcherDialogComponent {
  isDesktop = this.platform.is('desktop');

  constructor(
    private dialogRef: MatDialogRef<CatalogSwitcherDialogComponent>,
    private platform: Platform,
    @Inject(MAT_DIALOG_DATA) public data: CatalogSwitcherDialogData
  ) {}

  onSelectCatalog(catalog: Catalog) {
    this.dialogRef.close(catalog);
  }

  onClose() {
    this.dialogRef.close(null);
  }
}
